import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const e = "custom_fields";
class d extends o {
  /**
   * Creates a new custom field.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/custom_fields`
   *
   * @param {CustomFieldsCreationPayload} payload - The data for creating the custom field
   * @returns {Promise<CustomFieldsCreationData>} A promise resolving to the created custom field data
   */
  createCustomFields = async (t) => {
    const { data: s } = await this.post(
      e,
      t
    );
    return s;
  };
  /**
   * Edits an existing custom field.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/custom_fields/:customFieldsId`
   *
   * @param {number} customFieldsId - The ID of the custom field to edit
   * @param {CustomFieldsEditPayload} payload - The data for updating the custom field
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response
   */
  editCustomFields = async (t, s) => {
    const { data: a } = await this.put(
      `${e}/${t}`,
      s
    );
    return a;
  };
  /**
   * Deletes a custom field.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/custom_fields/:customFieldsId`
   *
   * @param {number} customFieldsId - The ID of the custom field to delete
   * @param {CustomFieldsDeletePayload} payload - The deletion parameters
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response
   */
  deleteCustomFields = async (t, s) => {
    const { data: a } = await this.delete(
      `${e}/${t}`,
      { params: s }
    );
    return a;
  };
  /**
   * Changes the order of custom fields.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/custom_fields/order`
   *
   * @param {CustomFieldsChangeOrderPayload} payload - The new order configuration
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response
   */
  changeOrderCustomFields = async (t) => {
    const { data: s } = await this.post(
      `${e}/order`,
      t
    );
    return s;
  };
}
export {
  e as CUSTOM_FIELDS_RESOURCE_URI,
  d as CustomFields
};
